import React from "react";
import api from "../utils/api";

const FanthonContext = React.createContext(null);

function FanthonContextProvider({ children, data: fanthon }) {
  const [public_key, setPublicKey] = React.useState(null);
  const [partner, setPartner] = React.useState(null);

  const getPublicKeyAndPartner = async () => {
    if (!fanthon.access_token) return;
    const response = await api.token(fanthon.access_token, fanthon.access_url);
    if (!response?.data) throw Error("without_connection");
    const { publicKey, partnerName } = response?.data || {};
    setPublicKey(publicKey);
    setPartner(partnerName);
  };

  const checkPayload = (elements) => {
    const payload = {};
    const keys = Object.keys(elements);
    keys.forEach((key) => {
      const { elementType, [key]: value, ...item } = elements[key];
      payload[key] = item;
      if (value) payload[key].value = value;
    });
    return payload;
  };

  const toSend = (elements, encryptedCard, params) => {
    const payload = checkPayload(elements);
    return (
      encryptedCard && {
        encrypted: encryptedCard,
        chosen_installment: payload?.chosen_installment?.value || 1,
        card: {
          brand: payload?.card_number?.brand,
          name: payload?.holder?.value,
          last4: payload.card_number?.value.replace(/[ ,\*]/gi, ""),
          exp_month: payload?.expiry?.exp_month,
          exp_year: payload?.expiry?.exp_year,
        },
        params,
      }
    );
  };

  const SERVICES = {
    click2pay: {
      createPaymentMethod: async ({
        secure: values,
        elements,
        params = {},
      }) => {
        const cardData = {
          holder: values?.holder?.trim(),
          number: values?.card_number?.trim(),
          expires: `${elements?.expiry?.exp_month?.trim()}/${elements?.expiry?.exp_year?.trim()}`,
          cvv: values?.cvv?.trim(),
        };

        const card = new CardHash(public_key);
        const getCardHash = async (cardData) => {
          return new Promise((resolve, reject) => {
            card.getCardHash(
              cardData,
              (encryptedCard) => resolve({ errors: [], encryptedCard }),
              (errors) => reject({ errors, encryptedCard: null }),
            );
          });
        };

        const response = await getCardHash(cardData);
        const { errors, encryptedCard } = response || {};
        const payment_method = toSend(elements, encryptedCard, params);
        return { errors, payment_method };
      },
    },
    pagseguro: {
      createPaymentMethod: async ({
        secure: values,
        elements,
        params = {},
      }) => {
        const cardData = {
          holder: values?.holder?.trim(),
          number: values?.card_number?.trim()?.replace(/[ ,_]/gi, ""),
          expMonth: elements?.expiry?.exp_month?.trim(),
          expYear: elements?.expiry?.exp_year?.trim(),
          securityCode: values?.cvv?.trim(),
          publicKey: public_key,
        };
        const response = global.PagSeguro.encryptCard(cardData);
        const { errors, encryptedCard } = response || {};
        const payment_method = toSend(elements, encryptedCard, params);
        return { errors, payment_method };
      },
    },
  };

  React.useEffect(() => {
    getPublicKeyAndPartner();
  }, [fanthon.access_token]);

  return (
    <FanthonContext.Provider
      value={{
        fanthon,
        public_key,
        partner,
        createPaymentMethod: partner && SERVICES[partner]?.createPaymentMethod,
      }}
    >
      {children}
    </FanthonContext.Provider>
  );
}

export { FanthonContextProvider, FanthonContext };
